
// 检查未登录就快速跳转的页面
const quick_authorize_url = [
  "/web/index-v3", // 公众号 福利兑换
  "/web/index-new", // HY首页
  "/web/user-cards", // 公众号 我的 我的卡券
  "/web/user-center-index", // 公众号 我的 个人中心
  "/web/user-center-help" // 公众号 我的 常见问题
]

// 检查必须绑卡的页面
const check_bind_card_url = [
  "/web/index-v3", // 公众号 首页 福利兑换
  "/web/index-new", // HY首页
  "/web/birthday" // 生日频道
]

var _array_contains_pathname_ = function(_array_) {
  for (var i = 0; i < _array_.length; i++) {
    if (_array_[i] == location.pathname) {
      return true
    }
  }

  return false
}

export function $is_quick_authorize_redirect() {
  return _array_contains_pathname_(quick_authorize_url)
}

export function $check_bind_card() {
  return _array_contains_pathname_(check_bind_card_url)
}